export default __webpack_public_path__ + "static/media/iosandroid.660237d2.png";